import { TFPageContent, TFPageHeader } from '@tf/shared';
import { T } from '@tf/utils';
import { ProfilesTable } from '@/components/profiles/ProfilesTable';
import { AddProfileButton } from '@/components/shared';
import { appStore } from '@/core/stores';

export const AccountListRoute = () => {
	const tenant = appStore.tenant?.get();
	T.assertNotNullish(tenant, 'no tenant in appStore');

	return (
		<>
			<TFPageHeader tenant={tenant} title="Accounts" toolbar={<AddProfileButton />} />
			<TFPageContent>
				<ProfilesTable emptyStatePrimaryAction={<AddProfileButton />} />
			</TFPageContent>
		</>
	);
};
